module.exports = __webpack_public_path__ + "static/img/23.98e47d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/23.jpg
// module id = rTnZ
// module chunks = 1